import {SeverityLevel} from '@zzng/common/models/error';

class RecommendCodeError extends Error {
  level: SeverityLevel;

  constructor(code: String) {
    super(`유효하지 않는 발급 추천카드 코드입니다. recommendCode: ${code}`);
    this.name = 'RecommendCodeError';
    this.level = 'warning';
  }
}

export default RecommendCodeError;
